module.exports = __webpack_public_path__ + "img/header_img4.0b1a86bc.png";